import EXIF from 'exif-js'

export default async function changeHandler(e) {
  let file = e.target.files[0]
  try {
    let src = await loadFile(file)
    let img = await loadImage(src)
    let {
      rotate = 1
    } = await loadEXIF(img)
    return getBase64(img, 1).src
    // target.src = src
  } catch (e) {
    throw e
  }
}

function loadFile(file) {
  return new Promise((resolve, reject) => {
    let reader = new FileReader()
    reader.onload = () => resolve(reader.result)
    reader.onerror = reject
    reader.readAsDataURL(file)
  })
}

function loadImage(src) {
  return new Promise((resolve, reject) => {
    let img = new Image()
    img.onload = () => resolve(img)
    img.onerror = reject
    img.src = src
  })
}

function loadEXIF(img) {
  return new Promise((resolve) => {
    EXIF.getData(img, function() {
      var tags = EXIF.getAllTags(this)
      resolve({
        rotate: tags.Orientation
      })
    })
  })
}

function getBase64(img, rotate) {
  let canvas = document.createElement('canvas')
  let ctx = canvas.getContext('2d')
  let { width, height } = img

  let scale = width > height ? 800 / width : 800 / height
  if (scale > 1) scale = 1

  let dw = width * scale
  let dh = height * scale

  canvas.width = rotate > 4 ? dh : dw
  canvas.height = rotate > 4 ? dw : dh

  let x = canvas.width / 2
  let y = canvas.height / 2

  ctx.translate(x, y)
  // mirror
  switch (rotate) {
    case 2:
    case 4:
    case 5:
    case 7:
      ctx.scale(-1, 1)
      break
  }
  // rotate
  switch (rotate) {
    case 3:
    case 4:
      ctx.rotate(180 * (Math.PI / 180))
      break
    case 5:
    case 6:
      ctx.rotate(90 * (Math.PI / 180))
      break
    case 7:
    case 8:
      ctx.rotate(-90 * (Math.PI / 180))
      break
  }
  // let temp
  if (rotate > 4) {
    [x, y] = [y, x]
  }
  ctx.drawImage(img, -x, -y, dw, dh)

  return {
    src: canvas.toDataURL(),
    width: rotate > 4 ? img.height : img.width,
    height: rotate > 4 ? img.width : img.height
  }
}